
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxBeauchamp = () => {
  return (
    <CityMetauxPage
      cityName="Beauchamp"
      departmentName="Val-d'Oise"
      departmentCode="95"
      region="Île-de-France"
      description="Située dans le Val-d'Oise, Beauchamp bénéficie de notre service de proximité pour le rachat de métaux urbains et industriels de la région parisienne."
      specialities={[
        "Métaux urbains et de démolition",
        "Équipements électriques et électroniques",
        "Métaux de construction francilienne",
        "Ferraille de rénovation urbaine"
      ]}
      nearbyAreas={[
        "Taverny", "Ermont", "Franconville", "Herblay", "Pierrelaye", "Bessancourt"
      ]}
      heroImage="https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=1280&q=80"
    />
  );
};

export default AchatMetauxBeauchamp;
